module.exports = __webpack_public_path__ + "./assets/icons/la-reine-astrid.png";